module.exports = __webpack_public_path__ + "static/media/mitie.ed3ac531.png";